/**
 * Design tokens for the invoice preview/PDF redesign.
 * See features/invoice-management/new-invoice-design/IMPLEMENTATION_CONTRACT.md §0.
 */

export const invoiceDesignTokens = Object.freeze({
  ink: '#191b1d',
  nearBlack: '#0b0b0b',
  itemName: '#2c2e31',
  serviceDate: '#46484b',
  muted: '#616368',
  orderDate: '#6f7276',
  label: '#7d8085',
  footerContact: '#8d8f93',
  footerBrand: '#9c9ea2',
  ruleStrong: '#dcdee1',
  ruleMeta: '#e3e5e7',
  ruleFooter: '#e6e8ea',
  ruleRow: '#edeef0',
  notesBg: '#f4f5f7',
  accent: '#3452eb',
  fontSize: Object.freeze({
    invoiceNumber: 22,
    grandTotal: 20,
    companyName: 15,
    metaValue: 13,
    groupHeader: 12.5,
    body: 12,
    description: 11.5,
    meta: 11,
    footerContact: 10,
    label: 9.5,
    footerBrand: 9
  }),
  statusPill: Object.freeze({
    draft: Object.freeze({ bg: '#eeeeee', color: '#555555' }),
    issued: Object.freeze({ bg: '#e3edff', color: '#2453d0' }),
    paid: Object.freeze({ bg: '#e2f6ea', color: '#1f8a4c' }),
    void: Object.freeze({ bg: '#fbe3e3', color: '#c73030' })
  })
});

export default invoiceDesignTokens;
